export default __webpack_public_path__ + "static/media/productHealthCheckPackage1_male_En.2d988a42.webp";